export const NO_PHYSICIAN = "NO_PHYSICIAN";
export const REQUIRED_TASKS = "Required Tasks";

export const TAB_NAMES = {
    PLAN: "plan",
    NOTES: "notes",
};

export const TAB_HEADERS = {
    CASE_DETAILS: "Case Details",
    SHARE_AND_NOTES: "Share & Notes",
};

export const PATIENT_INFO_HEADER = {
    ID: "ID",
    DOB: "DOB",
    PSA: "PSA",
    PATIENT_ID: "Patient ID: ",
    PLAN_ID: "Plan ID: ",
    VISIT_DATE: "Visit Date: ",
};

export const USER_ID = "User ID: ";

export const PLAN_DETAILS_HEADERS = {
    ASSIGNED_CLINICIAN: "Assigned Clinician",
    REQ_PATH_ENTRY: "Request Pathology Entry Services",
    REVIEW: "Mark Pre-service Tasks as Complete",
    INELIGIBLE: "Mark as Ineligible",
    QUALITY: "Flag Case",
    UPDATE_BIOPSY_TEMPLATE: "Update Biopsy Template",
};

export const SHARE_AND_NOTES_HEADERS = {
    SHARE_PATIENT: "Share Patient",
    PATIENT_NOTES: "Patient Notes",
};

export const PLAN_DETAILS_SUBHEADERS = {
    CANCEL_PATH_ENTRY: "Toggle off to cancel the pathology entry request",
    SEND_PATH_ENTRY: "Toggle on to send this case to Avenda Health",
    REVIEW_OFF:
        "Toggle off to mark as not ready for Cancer Estimation Map generation",
    REVIEW_ON:
        "Toggle on to mark as ready for Cancer Estimation Map generation",
    INELIGIBLE_OFF: "Toggle off to unmark this case as ineligible",
    INELIGIBLE_ON: "Toggle on to mark this case as ineligible",
    FLAG_OFF: "Toggle off to remove viewable note in Patient List",
    FLAG_ON: "Toggle to add viewable note in Patient List",
};

export const SHARE_AND_NOTES_SUBHEADER =
    "Give another user access to this patient case";

export const CHANGE_BIOPSY_TEMPLATE_PROMPT = {
    HEADER: "Change cartoon template?",
    BODY: "Switching templates will clear all data entered on the current cartoon. This can't be undone.",
    CANCEL_BTN: "Cancel",
    CONFIRM_BTN: "Confirm",
};

export const PLAN_DETAILS_PLACEHOLDERS = {
    SELECT_CLINICIAN: "Select Clinician",
    QUALITY_FLAG: "Describe why this case is flagged (required)",
    SELECT_BIOPSY_TEMPLATE: "Select a biopsy template",
};

export const SHARE_AND_NOTES_PLACEHOLDERS = {
    SHARE_PATIENT_DROPDOWN: "Select user to share with",
    SHARE_PATIENT_BTN: "Share Patient",
};

export const PATHOLOGY_REPORT_TOOLTIP_PROMPTS = {
    DEFAULT: "Request Pathology Entry Services",
    CANCEL: "Cancel Pathology Entry Services",
    INELIGIBLE:
        "Unmark this case as ineligible to be eligible for requesting pathology entry",
    FREEHAND: "Pathology entry services are not available for MRI-only cases",
    MISSING_PRIMARY_PHYSICIAN:
        "Assign a clinician to this plan to be eligible for requesting pathology entry",
    MISSING_PATHOLOGY:
        "Add Patient Pathology Report to be eligible for requesting pathology entry",
    MISSING_PSA:
        "Add Patient PSA to be eligible for requesting pathology entry",
    MISSING_ALL_REQS: {
        REGULAR:
            "Add patient PSA, a Pathology Report, and assign a clinician to be eligible for requesting pathology entry",
    },
};

export const NEEDS_REVIEW_TOGGLE_TOOLTIP_MSG = {
    DEFAULT: "Mark case as ready for review",
    CANCEL: "Cancel marking case as ready for review",
    MISSING_PATHOLOGY:
        "Please enter pathology data on the Pathology Input Page to mark a plan as ready for review",
};

export const INELIGIBLE_TOGGLE_TOOLTIP_MSG = {
    DEFAULT: "Mark case as ineligible",
    CANCEL: "Cancel marking case as ineligible",
    GENERATED_ERROR:
        "The case successfully generated a CEM and cannot be marked ineligible",
};

export const TIME_OUT_DURATION_MS = 3000;
export const PATIENT_SHARE_NO_NOTES = "Notes will appear here when posted.";
export const PATIENT_SHARE_ADD_NOTE_PLACEHOLDER =
    "Add a note for everyone to see (optional)";

export const INSTITUTION_REGEX_PATTERN = /^\w+-avendahelper@avendahealth\.com$/;
export const NAME_INSTITUTION_REGEX_PATTERN =
    /^[a-zA-Z0-9_.+-]+-[a-zA-Z0-9_.+-]+-avendahelper@avendahealth\.com$/;
export const AVENDA_EMAIL_REGEX_PATTERN =
    /^[a-zA-Z0-9_.+-]+@avendahealth\.com$/;
